import nineBoxLogo from "../assets/images/Group 1088453.png";
import successionnowLogo from "../assets/images/successionnowlogo.png";
import gametimeHrLogo from "../assets/images/gameTimeHr.png";
import orgChartLogo from "../assets/images/orgchartLogo.png";

ORGCHART_API_URL = "https://api.orgchrat.iosx.in/api/v1/";
ORGCHART_BASE_URL = "https://orgchartednow.com";

SUCCESSION_API_URL = "https://api.successionnow.com/api/v1/";
SUCCESSION_BASE_URL = "https://successionnow.com";

SOCKET_URL = "https://api.9boxnow.com/";

export const ALL_SITE_DATA = [
  {
    _id: 2,
    name: "9BoxNow",
    image: nineBoxLogo,
    code: "nineBoxNow",
    value: "nineBoxNow",
    color: "blue-500",
    isDisable: false,
    isDefault: true,
  },
  {
    _id: 4,
    name: "Org Chart",
    image: orgChartLogo,
    code: "orgChart",
    value: "orgChart",
    color: "orange-500",
    isDisable: false,
    isDefault: false,
  },
  {
    _id: 1,
    name: "SuccessionNow",
    image: successionnowLogo,
    code: "successionNow",
    value: "successionNow",
    color: "teal-500",
    isDisable: false,
    isDefault: false,
  },
  {
    _id: 3,
    name: "GameTime Hr",
    image: gametimeHrLogo,
    code: "gametimeHr",
    value: "gametimeHr",
    color: "green-500",
    isDisable: true,
    isDefault: false,
  },

  {
    _id: 5,
    name: "Bonus Now",
    image: null,
    code: "bonusNow",
    value: "bonusNow",
    color: "slate-600",
    isDisable: true,
    isDefault: false,
  },
];

export var ORGCHART_API_URL;
export var SUCCESSION_API_URL;
export var ORGCHART_BASE_URL;
export var SUCCESSION_BASE_URL;
export var SOCKET_URL;

export const sheduleLink = "http://meetings-na2.hubspot.com/jeff-delany";
// "https://calendly.com/cameronbrockbank/9box-now-demo"
